if (!customElements.get("low-power-video")) {
  customElements.define(
    "low-power-video",
    class LowPowerVideo extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.video_section = this.querySelector(".wt-video");
        this.video_background_section = this.querySelector(
          ".hero--video-background",
        );
        if (this.video_section) {
          this.checkAndPlayVideoSection(this.video_section);
        } else if (this.video_background_section) {
          this.checkAndPlayBackgroundVideoSection(
            this.video_background_section,
          );
        }
      }

      checkAndPlayBackgroundVideoSection(video_background_section) {
        const video_element = video_background_section.querySelector("video");
        if (!video_element) return;
        // The overlay is absent when the banner has no text, so fall back to the section itself.
        this.background_tap_target =
          video_background_section.querySelector(".hero__overlay") ||
          video_background_section;
        this.background_play_handler = () => this.playVideo(video_element);
        this.background_tap_target.addEventListener(
          "touchstart",
          this.background_play_handler,
        );
        this.background_tap_target.addEventListener(
          "click",
          this.background_play_handler,
        );
      }

      checkAndPlayVideoSection(video) {
        const video_element = video.querySelector("video");
        if (video_element) {
          video.addEventListener("touchstart", () =>
            this.playVideo(video_element),
          );
          video.addEventListener("click", () => this.playVideo(video_element));
        }
      }

      playVideo(video_element) {
        if (!video_element.playing) {
          video_element.play();
        }
      }

      disconnectedCallback() {
        if (this.video_section) {
          this.video_section.removeEventListener("touchstart", this.playVideo);
          this.video_section.removeEventListener("click", this.playVideo);
        }
        if (this.background_tap_target && this.background_play_handler) {
          this.background_tap_target.removeEventListener(
            "touchstart",
            this.background_play_handler,
          );
          this.background_tap_target.removeEventListener(
            "click",
            this.background_play_handler,
          );
        }
      }
    },
  );
}
